import Rollbar from 'rollbar'

// Stack sources outside our control: browser extensions (ad blockers) and
// third-party tag scripts whose blocked tracking beacons surface as
// uncaught "Failed to fetch" rejections.
const THIRD_PARTY_STACK_SOURCES = [
  'chrome-extension://',
  'moz-extension://',
  'safari-extension://',
  'safari-web-extension://',
  'www.googletagmanager.com',
  'www.google-analytics.com',
  'connect.facebook.net',
]

// Where our own code runs from: the Vite bundle in production, source modules
// in dev. A stack with frames but none of them here comes from a script
// injected at runtime (GTM Custom HTML tags such as the OpenAI pixel, in-app
// browser webviews), which Safari attributes to the page URL itself.
const OWN_STACK_SOURCES = ['/assets/', '/src/', '/node_modules/']

interface TraceFrame {
  filename?: string
}

interface TracePayload {
  body?: {
    trace?: { frames?: TraceFrame[] }
    trace_chain?: { frames?: TraceFrame[] }[]
  }
}

export const isThirdPartyError = (payload: TracePayload): boolean => {
  const body = payload.body
  const traces = body?.trace_chain ?? (body?.trace ? [body.trace] : [])
  const frames = traces.flatMap((trace) => trace?.frames ?? [])

  const fromThirdParty = frames.some((frame) =>
    THIRD_PARTY_STACK_SOURCES.some((source) => frame.filename?.includes(source))
  )
  const fromOwnCode = frames.some((frame) =>
    OWN_STACK_SOURCES.some((source) => frame.filename?.includes(source))
  )

  return fromThirdParty || (frames.length > 0 && !fromOwnCode)
}

const rollbar = new Rollbar({
  accessToken: import.meta.env.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: import.meta.env.VITE_ROLLBAR_ENV,
  checkIgnore: (isUncaught, _args, payload) =>
    isUncaught && isThirdPartyError(payload as TracePayload),
})

export default rollbar
